import {
  PUT_PROFILE_CARDS_CATALOG,
  PUT_PROFILE_CARDS_CATALOG_SUCCESS,
  PUT_PROFILE_CARDS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putProfileCardCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_PROFILE_CARDS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_PROFILE_CARDS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_PROFILE_CARDS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
